import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import Breadcrumb from '../../../core/common/Breadcrumb/breadcrumb';
import Sidebar from '../sidebar/sidebar';
import { all_routes } from '../../router/all_routes';

interface AvaliacaoFotoPontoDTO {
    fotoId: number;
    ponto: string;
    url: string;
}

interface AvaliacaoDTO {
    id: number;
    nota: number;
    comentario: string;
    fotos: number[];
    fotosPorPonto: AvaliacaoFotoPontoDTO[];
    status: string;
    usuarioNome: string;
    usuarioFotoUrl: string;
    motoristaNome: string;
    pacoteNome: string;
    pacoteId: number;
}

const AgentReviews: React.FC = () => {
    const routes = all_routes;
    const baseUrl = process.env.REACT_APP_API_URL; // base que já inclui /api

    const breadcrumbs = [
        { label: 'Reviews', active: false, link: routes.home1 },
        { label: 'Reviews', active: true },
    ];

    const [reviews, setReviews] = useState<AvaliacaoDTO[]>([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchReviews = async () => {
            try {
                const token = localStorage.getItem('token');
                const res = await axios.get(`${baseUrl}/empresas/dashboard/reviews`, {
                    headers: token ? { Authorization: `Bearer ${token}` } : undefined,
                });
                console.log(res.data);
                setReviews(res.data);
            } catch (err) {
                console.error('Erro ao buscar reviews:', err);
            } finally {
                setLoading(false);
            }
        };

        fetchReviews();
    }, [baseUrl]);

    if (loading) {
        return <p>Carregando reviews...</p>;
    }

    return (
        <div>
            <Breadcrumb title="Reviews" breadcrumbs={breadcrumbs} backgroundClass="breadcrumb-bg-04" />

            <div className="content">
                <div className="container">
                    <div className="row">
                        <div className="col-xl-3 col-lg-4">
                            <Sidebar />
                        </div>
                        <div className="col-xl-9 col-lg-8">
                            {/* Review Title */}
                            <div className="card mb-3">
                                <div className="card-body">
                                    <h6>Reviews</h6>
                                    <p className="fs-14 mb-1">No of Reviews : {reviews.length}</p>
                                    <p className="fs-14 text-muted mb-1">
                                        Abaixo estão as avaliações mais recentes dos seus pacotes.
                                    </p>
                                    <p className="fs-14 text-muted">
                                        Para ver mais detalhes das avaliações, acesse a página{" "}
                                        <Link to={routes.agentServiceEnrollment} className="text-primary text-decoration-underline">
                                            Service Enrollment
                                        </Link>{" "}
                                        e clique em “Ver avaliações” no pacote desejado.
                                    </p>
                                </div>
                            </div>

                            {/* Reviews */}
                            {reviews.map((review) => (
                                <div key={review.id} className="card shadow-none mb-3">
                                    <div className="card-body">
                                        <div className="d-flex align-items-center mb-3">
                                            <span className="avatar avatar-lg rounded-circle flex-shrink-0 me-2">
                                                <img
                                                    src={
                                                        review.usuarioFotoUrl
                                                            ? `${baseUrl}${review.usuarioFotoUrl}`
                                                            : '/assets/img/users/default.jpg'
                                                    }
                                                    alt={review.usuarioNome}
                                                    className="img-fluid rounded-circle"
                                                />
                                            </span>
                                            <div>
                                                <h6 className="fs-16">{review.usuarioNome}</h6>
                                                <div className="d-flex align-items-center flex-wrap">
                                                    <span className="fs-14 d-flex align-items-center me-2">
                                                        {review.status}
                                                    </span>
                                                    <span className="badge badge-xs badge-warning text-gray-9 me-2">
                                                        {review.nota}
                                                    </span>
                                                </div>
                                            </div>
                                        </div>

                                        <p className="fs-14 d-flex align-items-center mb-2">
                                            <i className="isax isax-info-circle5 text-gray-9 me-2" />
                                            Info: <Link to={`/flight-details/${review.pacoteId}`}>{review.pacoteNome}</Link>
                                        </p>

                                        <p className="fs-16 mb-2">{review.comentario}</p>

                                        {/* Fotos gerais + por ponto — juntas na mesma linha */}
                                        {(review.fotos.length > 0 || review.fotosPorPonto.length > 0) && (
                                            <div
                                                className="d-flex flex-wrap align-items-center gap-2 mt-2"
                                                style={{ rowGap: '8px', columnGap: '8px' }}
                                            >
                                                {/* Fotos gerais */}
                                                {review.fotos.map((fotoId) => (
                                                    <img
                                                        key={`geral-${fotoId}`}
                                                        src={`${baseUrl}/uploads/${fotoId}`}
                                                        alt={`Foto avaliação ${fotoId}`}
                                                        className="img-fluid rounded"
                                                        style={{
                                                            width: '100px',
                                                            height: '100px',
                                                            objectFit: 'cover',
                                                            border: '1px solid #eee',
                                                        }}
                                                    />
                                                ))}

                                                {/* Fotos por ponto */}
                                                {review.fotosPorPonto.map((foto) => (
                                                    <img
                                                        key={`ponto-${foto.fotoId}`}
                                                        src={`${baseUrl}${foto.url}`}
                                                        alt={foto.ponto}
                                                        title={foto.ponto}
                                                        className="img-fluid rounded"
                                                        style={{
                                                            width: '100px',
                                                            height: '100px',
                                                            objectFit: 'cover',
                                                            border: '1px solid #eee',
                                                        }}
                                                    />
                                                ))}
                                            </div>
                                        )}
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default AgentReviews;